import { http } from "@/core/api/";
const apiUrl = "api/inventoryorderbooks";

export default {
  searchForAdd(params) {
    return http.get(`${apiUrl}/add/search`, { params });
  },
  searchForSelectedAdd(params) {
    return http.get(`${apiUrl}/add/searchforselected`, { params });
  },
  getFilters() {
    return http.get(`${apiUrl}/filters`);
  },
  search(params) {
    return http.get(`${apiUrl}/search`, { params });
  },
  searchMyBooks(params) {
    return http.get(`${apiUrl}/mine/search`, { params });
  },
  existBook(params) {
    return http.get(`${apiUrl}/existbook`, { params });
  },
  getReasons() {
    return http.get(`${apiUrl}/reasons`);
  },
  save(data) {
    return http.post(`${apiUrl}/save`, data);
  },
  submit(orderId) {
    return http.post(`${apiUrl}/submit/${orderId}`);
  },
  trackRequestProgress(id) {
    return http.get(`${apiUrl}/trackrequest/${id}`);
  },
  searchRequest(params) {
    return http.get(`${apiUrl}/searchrequest`, { params });
  },
  nofityLoanExtensionDate(data) {
    return http.post(`${apiUrl}/nofityloanextensiondate/`, data);
  },
  rejectRequest(data) {
    return http.post(`${apiUrl}/rejectrequest`, data);
  },
  deliveryCsee(data) {
    return http.post(`${apiUrl}/deliveryCsee`, data);
  },
  get(id) {
    return http.get(`${apiUrl}/${id}`);
  },
  getBookRequestAssignmentDate(orderId) {
    return http.get(`${apiUrl}/order/${orderId}/assignmentDate`);
  },
  changeStatusToPendingDeliveryTeacher(data) {
    return http.post(`${apiUrl}/sendtoteacher`, data);
  },
  getBookRequestSchoolDeliveryDate(orderId) {
    return http.get(`${apiUrl}/order/${orderId}/schoolDeliveryDate`);
  },
  getBookRequestPendingTeacherDeliveryDate(orderId) {
    return http.get(`${apiUrl}/order/${orderId}/pendingTeacherDeliveryDate`);
  },
  changeStatusToDelivered(data) {
    return http.post(`${apiUrl}/deliveredToTeacher`, data);
  },
  requestToPurchase(id, data) {
    return http.post(`${apiUrl}/${id}/request/purchase`, data);
  },
  transfer(data) {
    return http.post(`${apiUrl}/transfer`, data);
  },
  getTransferInfo(bookId) {
    return http.get(`${apiUrl}/transfer/${bookId}`);
  },
  cancelTransfer(data) {
    return http.post(`${apiUrl}/transfer/cancel/`, data);
  },
  approveOrderPurchase(data) {
    return http.post(`${apiUrl}/approvepurchase`, data);
  },
  confirmPurchase(data) {
    return http.post(`${apiUrl}/confirmpurchase`, data);
  },
  removeOrder(id) {
    return http.put(`${apiUrl}/removeorder/${id}`);
  },
  getPurchaseDetails(id) {
    return http.get(`${apiUrl}/order/${id}/purchase/details`);
  },
  searchStudentsWithBook(params) {
    return http.get(`${apiUrl}/searchstudentwithbook`, { params });
  },
  getOrderHistory(id) {
    return http.get(`${apiUrl}/order/${id}/history`);
  },
  getStudentAssignedBooks(params) {
    return http.get(`${apiUrl}/student/assignedbooks`, { params });
  },
};
